import {
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import InfoModal from 'src/components/InfoModal';
import InfoPopupContent from 'src/__mocks__/InfoPopupContent';

const LastUpdatedCard = (props) => {
  const { value } = props;
  let date = '';
  let time = '';
  if (value) {
    const split = value.split('T');
    [date, time] = split;
    [time] = time.split('.');
  }

  const cardStyle = {
    display: "block",
    height: "100%"
  };



  return (
    <Card style={cardStyle}>
      <CardContent>
        <Typography
          color="textSecondary"
          gutterBottom
          variant="h6"
        >
          LAST UPDATED:
          <InfoModal content={InfoPopupContent.LAST_UPDATED} />
        </Typography>
        <Typography
          color="textSecondary"
          gutterBottom
          variant="h4"
        >
          <b>{ date }</b>
          <br />
          <b>{time}</b>
        </Typography>
      </CardContent>
    </Card>
  );
};
LastUpdatedCard.propTypes = {
  value: PropTypes.string
};

export default LastUpdatedCard;
